import React, { forwardRef, memo, useRef } from "react";

import { OrcaPropTypes } from "./OrcaPropTypes";
import { OrcaContextProvider } from "./contexts/OrcaContextProvider";
import { VodDataProvider } from "./contexts/VideoDataContext/VodDataProvider";
import { LoopingFeatureStack } from "./contexts/featureStacks/LoopingFeatureStack";
import { LoopingPlayer } from "./components/LoopingPlayer";
import { OrcaOrYoutube } from "./components/OrcaOrYoutube";

const OrcaLooping = forwardRef(
  (
    {
      uuid,
      video,
      videoStartId,
      onVideoEnded = () => {},
      onVideoRendered = () => {},
      config = {},
      promoEnabled = true,
      isSandbox = false,
      orcaDeps
    },
    ref
  ) => {
    const videoProps = {
      onVideoEnded,
      onVideoRendered,
      config,
      promoEnabled,
      isSandbox
    };

    const defaultRef = useRef();
    const orcaRef = ref ?? defaultRef;

    return (
      <OrcaContextProvider
        DataProviderComponent={VodDataProvider}
        OptionalFeatureStack={LoopingFeatureStack}
        uuid={uuid}
        video={video}
        videoStartId={videoStartId}
        isSandbox={isSandbox}
        config={config}
        orcaRef={orcaRef}
        orcaDeps={orcaDeps}
      >
        <OrcaOrYoutube
          forwardedRef={orcaRef}
          Player={LoopingPlayer}
          {...videoProps}
        />
      </OrcaContextProvider>
    );
  }
);

OrcaLooping.displayName = "Orca";

OrcaLooping.propTypes = OrcaPropTypes;

const MemoOrca = memo(OrcaLooping);

export { MemoOrca as OrcaLooping };
